<template>
  <div class="">
    <Card class="">
      <template #title>
        Danışan Bilgileri - <b>{{ MusteriIsim }}</b>
      </template>
      <template #content>
        <div class="grid">
          <div class="col-12">
            <Tabs value="0">
              <TabList>
                <Tab value="0">Genel Bilgiler</Tab>
                <Tab value="1">Vücut İndex</Tab>
                <Tab value="3">Diyet Atama</Tab>
                <Tab value="4">Diyet Detay</Tab>
                <Tab value="5">Geçmiş İşlemler</Tab>
                <Tab value="6" disabled>Boş</Tab>
              </TabList>
              <TabPanels>
                <!-- GENEL BİLGİLER -->
                <TabPanel value="0">
                  <GenelBilgiler :pMusteri="this.Musteri_rowid" />
                </TabPanel>
                <!-- Vucut Index BİLGİLERİ -->
                <TabPanel value="1">
                  <VucutVerileri :pMusteri="this.Musteri_rowid" />
                </TabPanel>
                <!-- Diyet Ata -->
                <TabPanel value="3">
                  <DiyetAta :pMusteri="this.Musteri_rowid" />
                </TabPanel>

                <TabPanel value="4">
                  <DiyetDetay :pMusteri="this.Musteri_rowid" />
                </TabPanel>
                <TabPanel value="5">
                  <DanisanGecmisIslemler :pMusteri="this.Musteri_rowid" />
                </TabPanel>
                <TabPanel value="6">

                </TabPanel>
              </TabPanels>
            </Tabs>
          </div>
        </div>

      </template>
    </Card>
  </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";
import DanisanGecmisIslemler from "./DetayDanisman/DanisanGecmisIslemler.vue"
import GenelBilgiler from "./DetayDanisman/GenelBilgiler.vue"
import VucutVerileri from "./DetayDanisman/VucutVerileri/VucutVerileri.vue"
import DiyetAta from "./DetayDanisman/DiyetAta.vue"
import DiyetDetay from "./DetayDanisman/DiyetDetay/DiyetDetay.vue"
export default {
  data() {
    return {
      Musteri_rowid: 0,
      MusteriIsim: "",
      IsWait: false,
    };
  },
  methods: {
    _getMusteriAd() {
      let data = {
        Musteri_rowid: this.$route.query.DanisanNo,
      };

      GlobalServis.GlobalServis("POST", "GetMusteriInfo", data).then((res) => {
        if (res.status == 200) {
          this.MusteriIsim = res.data[0].Isim;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });

    }
  },
  created() {
    this.Musteri_rowid = this.$route.query.DanisanNo;
    this._getMusteriAd();
  },

  components: {
    DanisanGecmisIslemler,
    GenelBilgiler,
    DiyetAta,
    DiyetDetay,
    VucutVerileri
  },
};
</script>